// Interakcje frontu: navbar (cień po przewinięciu, menu mobilne),
// lightbox plakatu zbiórki i komunikat po wysłaniu formularza CF7.

function initHeader() {
  const header = document.querySelector( '.site-header' );
  if ( ! header ) return;

  const onScroll = () => header.classList.toggle( 'is-scrolled', window.scrollY > 50 );
  onScroll();
  window.addEventListener( 'scroll', onScroll, { passive: true } );

  const toggle = header.querySelector( '.nav-toggle' );
  const panel = document.getElementById( 'mobile-nav' );
  if ( ! toggle || ! panel ) return;

  const setOpen = ( open ) => {
    toggle.setAttribute( 'aria-expanded', String( open ) );
    toggle.setAttribute( 'aria-label', open ? 'Zamknij menu' : 'Otwórz menu' );
    panel.classList.toggle( 'is-open', open );
  };

  toggle.addEventListener( 'click', () => setOpen( toggle.getAttribute( 'aria-expanded' ) !== 'true' ) );
  panel.querySelectorAll( 'a' ).forEach( ( link ) => link.addEventListener( 'click', () => setOpen( false ) ) );
  document.addEventListener( 'keydown', ( event ) => {
    if ( event.key === 'Escape' && toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
      setOpen( false );
      toggle.focus();
    }
  } );
  window.addEventListener( 'resize', () => {
    if ( window.innerWidth >= 1024 ) setOpen( false );
  } );
}

function initLightbox() {
  let active = null;
  let opener = null;

  const close = () => {
    if ( ! active ) return;
    active.hidden = true;
    active = null;
    document.body.classList.remove( 'lg-no-scroll' );
    if ( opener ) opener.focus();
  };

  document.addEventListener( 'click', ( event ) => {
    const open = event.target.closest( '[data-lightbox-open]' );
    if ( open ) {
      const box = document.getElementById( open.getAttribute( 'data-lightbox-open' ) );
      if ( ! box ) return;
      // Lightbox przenosimy do <body>, żeby żaden kontener nie ograniczał position:fixed.
      if ( box.parentElement !== document.body ) document.body.appendChild( box );
      opener = open;
      active = box;
      box.hidden = false;
      box.scrollTop = 0;
      document.body.classList.add( 'lg-no-scroll' );
      box.querySelector( '[data-lightbox-close]' )?.focus();
      return;
    }

    if ( ! active ) return;
    if ( event.target.closest( '[data-lightbox-close]' ) || ! event.target.closest( '.lg-lightbox__box' ) ) {
      close();
    }
  } );

  document.addEventListener( 'keydown', ( event ) => {
    if ( event.key === 'Escape' ) close();
  } );
}

function initContactForm() {
  document.addEventListener( 'wpcf7mailsent', ( event ) => {
    const wrap = event.target.closest( '[data-contact-form]' );
    if ( ! wrap ) return;
    wrap.querySelector( '.lg-contact__form-body' ).hidden = true;
    wrap.querySelector( '.lg-contact__success' ).hidden = false;
  } );

  document.addEventListener( 'click', ( event ) => {
    const again = event.target.closest( '[data-contact-again]' );
    if ( ! again ) return;
    const wrap = again.closest( '[data-contact-form]' );
    wrap.querySelector( '.lg-contact__success' ).hidden = true;
    wrap.querySelector( '.lg-contact__form-body' ).hidden = false;
    wrap.querySelector( 'input:not([type=hidden])' )?.focus();
  } );
}

function init() {
  initHeader();
  initLightbox();
  initContactForm();
}

if ( document.readyState === 'loading' ) {
  document.addEventListener( 'DOMContentLoaded', init );
} else {
  init();
}
